module.exports = __webpack_public_path__ + "img/QRcode-hover.8b1cc6c4.png";